export const getCityStateFromLocation = location => {
  const locationArray = location?.split(',');
  const state = locationArray && locationArray[1] ? locationArray[1].trim() : '';
  const city = locationArray && locationArray[0] ? locationArray[0].trim() : '';
  return [city, state];
};
